export default function Empty() {
    return (
        <svg
            width="430"
            height="413"
            viewBox="0 0 430 413"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M231.702 412.171H392.763C413.319 412.171 429.993 395.511 429.993 374.943V37.2277C429.98 16.6604 413.319 0 392.763 0H231.702C211.146 0 194.471 16.6604 194.471 37.2277V374.956C194.471 395.511 211.133 412.171 231.702 412.171Z"
                fill="#D4E2FF"
            />
            <path
                d="M214.357 412.171H375.418C395.974 412.171 412.649 395.511 412.649 374.943V37.2277C412.649 16.6604 395.974 0 375.418 0H214.357C193.801 0 177.127 16.6604 177.127 37.2277V374.956C177.14 395.511 193.801 412.171 214.357 412.171Z"
                fill="#3EA2E5"
            />
            <path
                d="M214.137 400.894H375.643C389.795 400.894 401.269 389.421 401.269 375.27V39.2532C401.269 25.1017 389.795 13.6289 375.643 13.6289H214.137C199.985 13.6289 188.511 25.1017 188.511 39.2532V375.27C188.511 389.421 199.985 400.894 214.137 400.894Z"
                fill="white"
            />
            <path
                d="M255.413 26.212H332.631C336.459 26.212 339.557 23.1152 339.557 19.2865V8.00977H248.5V19.2996C248.487 23.1152 251.584 26.212 255.413 26.212Z"
                fill="#3EA2E5"
            />
            <path
                d="M377.636 66.3018H211.087V201.519H377.636V66.3018Z"
                fill="#FFBB38"
            />
            <path
                d="M236.221 96.7324C235.594 96.7324 235.084 97.242 235.084 97.8692C235.084 98.4965 235.594 99.0061 236.221 99.0061H251.288C257.182 113.706 263.062 128.407 268.943 143.107L263.454 156.265C263.141 156.958 263.755 157.873 264.513 157.86H321.11C321.711 157.873 322.26 157.324 322.26 156.723C322.26 156.122 321.711 155.586 321.11 155.586H266.212L270.981 144.165L326.873 139.71C327.33 139.67 327.748 139.305 327.866 138.86L334.661 109.433C334.805 108.78 334.243 108.062 333.563 108.048H257.378L253.131 97.4381C252.961 97.0199 252.516 96.7324 252.072 96.7324H236.221ZM258.292 110.309H332.152L325.853 137.54L270.916 141.931L258.292 110.309ZM276.966 162.381C271.975 162.381 267.91 166.445 267.91 171.436C267.91 176.428 271.975 180.492 276.966 180.492C281.958 180.492 286.022 176.428 286.022 171.436C286.022 166.445 281.945 162.381 276.966 162.381ZM308.656 162.381C303.664 162.381 299.6 166.445 299.6 171.436C299.6 176.428 303.664 180.492 308.656 180.492C313.648 180.492 317.712 176.428 317.712 171.436C317.712 166.445 313.648 162.381 308.656 162.381ZM276.966 164.641C280.73 164.641 283.762 167.673 283.762 171.436C283.762 175.2 280.73 178.231 276.966 178.231C273.203 178.231 270.171 175.2 270.171 171.436C270.171 167.673 273.203 164.641 276.966 164.641ZM308.656 164.641C312.42 164.641 315.451 167.673 315.451 171.436C315.451 175.2 312.42 178.231 308.656 178.231C304.892 178.231 301.861 175.2 301.861 171.436C301.861 167.673 304.892 164.641 308.656 164.641Z"
                fill="white"
            />
            <path
                d="M334.643 119.576C341.752 119.576 347.515 113.813 347.515 106.705C347.515 99.5965 341.752 93.834 334.643 93.834C327.534 93.834 321.771 99.5965 321.771 106.705C321.771 113.813 327.534 119.576 334.643 119.576Z"
                fill="#27AE60"
            />
            <path
                d="M328.922 107.345L333.744 110.873L339.481 103.582"
                stroke="white"
                strokeWidth="1.6991"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M214.098 360.387V223.132H376.009V360.387H214.098Z"
                stroke="#FFBB38"
                strokeWidth="1.0886"
                strokeMiterlimit="10"
            />
            <path
                d="M237.95 245.09L240.652 250.572L240.769 250.808L241.029 250.846L247.069 251.72L242.699 255.977L242.511 256.161L242.555 256.42L243.586 262.45L238.184 259.604L237.952 259.481L237.719 259.604L232.303 262.452L233.335 256.42L233.379 256.161L233.191 255.977L228.821 251.72L234.861 250.846L235.121 250.808L235.237 250.572L237.95 245.09Z"
                fill="#FFBB38"
                stroke="#FFBB38"
            />
            <path
                d="M266.253 245.092L268.954 250.572L269.07 250.808L269.331 250.846L275.371 251.72L271.001 255.977L270.812 256.161L270.857 256.42L271.888 262.45L266.486 259.604L266.253 259.481L266.02 259.604L260.618 262.45L261.649 256.42L261.694 256.161L261.505 255.977L257.135 251.72L263.175 250.846L263.436 250.808L263.552 250.572L266.253 245.092Z"
                fill="#FFBB38"
                stroke="#FFBB38"
            />
            <path
                d="M294.572 245.09L297.274 250.572L297.391 250.808L297.651 250.846L303.691 251.72L299.321 255.977L299.133 256.161L299.177 256.42L300.208 262.45L294.807 259.604L294.574 259.481L294.341 259.604L288.925 262.452L289.957 256.42L290.001 256.161L289.813 255.977L285.443 251.72L291.483 250.846L291.743 250.808L291.859 250.572L294.572 245.09Z"
                fill="#FFBB38"
                stroke="#FFBB38"
            />
            <path
                d="M322.883 245.092L325.583 250.572L325.7 250.808L325.96 250.846L332.011 251.72L327.631 255.977L327.442 256.16L327.486 256.42L328.518 262.45L323.116 259.604L322.883 259.481L322.65 259.604L317.248 262.45L318.279 256.42L318.323 256.161L318.135 255.977L313.765 251.72L319.805 250.846L320.065 250.808L320.182 250.572L322.883 245.092Z"
                fill="#FFBB38"
                stroke="#FFBB38"
            />
            <path
                d="M351.195 245.09L353.896 250.572L354.013 250.808L354.273 250.846L360.313 251.72L355.943 255.977L355.755 256.161L355.799 256.42L356.83 262.45L351.429 259.604L351.196 259.481L350.963 259.604L345.547 262.452L346.579 256.42L346.623 256.161L346.435 255.977L342.065 251.72L348.105 250.846L348.365 250.808L348.481 250.572L351.195 245.09Z"
                fill="#D4E2FF"
                stroke="#D4E2FF"
            />
            <path
                d="M314.787 299.077H238.235C232.446 299.077 227.742 294.373 227.742 288.585C227.742 282.796 232.446 278.092 238.235 278.092H314.787C320.576 278.092 325.28 282.796 325.28 288.585C325.28 294.373 320.576 299.077 314.787 299.077Z"
                stroke="#FFBB38"
                strokeWidth="0.9301"
                strokeMiterlimit="10"
            />
            <path
                d="M356.534 296.778C361.061 292.251 361.061 284.913 356.534 280.386C352.008 275.86 344.669 275.86 340.142 280.386C335.615 284.913 335.615 292.251 340.142 296.778C344.669 301.304 352.008 301.304 356.534 296.778Z"
                fill="#FFCF3C"
            />
            <path
                d="M227.742 316.051H357.388"
                stroke="#FFBB38"
                strokeWidth="1.0886"
                strokeMiterlimit="10"
            />
            <path
                d="M227.742 329.288H276.511"
                stroke="#FFBB38"
                strokeWidth="1.0886"
                strokeMiterlimit="10"
            />
            <path
                d="M99.3803 372.199L95.9566 390.14H81.5297L84.9012 371.376L99.3803 372.199Z"
                fill="#FFB8BC"
            />
            <path
                d="M100.831 388.01V397.131L112.997 401.456C116.787 402.893 119.387 406.395 119.675 410.42L119.884 412.772L72.4476 412.667L77.1521 387.801L100.831 388.01Z"
                fill="#2D4559"
            />
            <path
                d="M109.389 399.182L106.122 402.553"
                stroke="white"
                strokeWidth="0.7972"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M104.492 398.059L101.225 401.43"
                stroke="white"
                strokeWidth="0.7972"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M97.2737 203.936L100.083 212.521L125.03 281.331C127.016 286.401 127.029 292.033 125.043 297.116L106.382 375.191L76.2214 375.152L93.7193 291.707L62.082 203.688L97.2737 203.936Z"
                fill="#2D4559"
            />
            <path
                d="M76.6155 243.947L93.0679 234.865L82.6659 260.803L76.6155 243.947Z"
                fill="#2D4559"
            />
            <path
                d="M45.5485 372.199L42.1378 390.14H27.7109L31.0694 371.376L45.5485 372.199Z"
                fill="#FFB8BC"
            />
            <path
                d="M47.0095 388.01V397.131L59.1756 401.456C62.9653 402.893 65.5658 406.395 65.8533 410.42L66.0624 412.772L18.6261 412.667L23.3305 387.801L47.0095 388.01Z"
                fill="#2D4559"
            />
            <path
                d="M55.553 399.183L52.286 402.554"
                stroke="white"
                strokeWidth="0.7972"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M50.6689 398.059L47.3889 401.43"
                stroke="white"
                strokeWidth="0.7972"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M49.4246 207.282L49.4115 207.347L49.307 207.19C49.307 207.19 39.4669 216.598 42.1589 250.951L42.3549 250.52L21.3418 375.989L49.7382 376.459L84.2635 203.767L49.4246 207.282Z"
                fill="#2D4559"
            />
            <path
                d="M94.8751 141.672L134.366 157.065C140.09 160.802 141.959 168.329 138.626 174.3C135.137 180.559 128.786 182.075 120.959 179.37L80.0039 166.395C74.0058 163.089 71.157 156.02 73.1956 149.473C76.0574 140.326 86.8515 136.445 94.8751 141.672Z"
                fill="#3EA2E5"
            />
            <path
                d="M146.626 120.032C146.953 116.06 147.462 111.317 147.75 109.357C147.907 108.233 148.795 107.358 149.919 107.201C151.265 107.005 152.533 107.906 152.794 109.252L153.238 113.355L161.772 102.052C162.386 101.229 163.523 100.889 164.438 101.373C165.509 101.922 165.862 103.228 165.287 104.235L164.307 106.469L165.653 104.679C166.241 103.895 167.326 103.594 168.175 104.078C169.155 104.64 169.442 105.881 168.828 106.796L168.044 108.063C168.907 107.135 170.044 106.835 170.762 107.371C171.573 107.946 171.782 109.069 171.233 109.906L170.004 111.526C171.233 109.906 172.174 110.18 172.723 110.598C173.48 111.173 173.663 112.231 173.141 113.015L168.841 121.81C167.914 123.717 166.685 125.455 165.209 126.971C163.183 129.036 160.217 131.793 157.891 132.851L149.958 127.729C149.945 127.716 146.09 126.435 146.626 120.032Z"
                fill="#FFB8BC"
            />
            <path
                d="M152.876 79.3078C152.876 99.3612 169.132 115.618 189.186 115.618C209.239 115.618 225.496 99.3612 225.496 79.3078C225.496 59.2545 209.239 42.998 189.186 42.998C169.132 42.998 152.876 59.2545 152.876 79.3078Z"
                fill="#EF262C"
            />
            <path
                d="M203.129 70.1404C199.953 67.0304 194.857 67.0827 191.747 70.258L189.695 72.3487L187.591 70.2711C184.429 67.148 179.332 67.1872 176.209 70.3625C173.099 73.5247 173.125 78.6208 176.301 81.7438L184.128 89.4533C184.141 89.4664 184.154 89.4925 184.167 89.5056C185.422 90.7339 186.964 91.4657 188.571 91.7139C191.041 92.0929 193.668 91.3219 195.549 89.388L203.246 81.5217C206.357 78.3464 206.304 73.2503 203.129 70.1404Z"
                fill="white"
            />
            <path
                d="M119.331 162.356L146.42 123.939L161.331 131.139L138.201 175.214C134.346 181.486 125.668 182.532 120.428 177.37C116.364 173.333 115.894 166.93 119.331 162.356Z"
                fill="#3EA2E5"
            />
            <path
                d="M85.6333 139.202L40.7322 140.992C36.6811 141.149 33.7539 144.925 34.6034 148.885L49.3047 207.202L97.1461 203.857L94.4541 147.277C94.2189 142.612 90.2854 139.019 85.6333 139.202Z"
                fill="#3EA2E5"
            />
            <path
                d="M49.2558 167.375L19.2258 191.366C13.5805 195.234 7.22956 196.919 2.98251 191.562C-1.47363 185.943 -0.545812 177.776 5.06029 173.307L32.0977 144.194C37.4555 139.921 45.074 139.987 50.3404 144.377C57.6976 150.505 57.1618 161.965 49.2558 167.375Z"
                fill="#3EA2E5"
            />
            <path
                d="M21.4082 178.129L44.6036 218.519L31.9931 229.247L2.02857 190.203C-2.15314 184.153 0.395093 175.777 7.24265 173.085C12.5613 170.982 18.6247 173.138 21.4082 178.129Z"
                fill="#3EA2E5"
            />
            <path
                d="M55.058 218.649C48.3934 220.413 42.0033 223.314 36.0312 227.065C37.3903 228.659 39.0499 230.24 40.422 231.468C42.0947 232.971 44.0026 234.186 46.0543 235.088L55.5677 239.243C56.4302 239.766 57.5409 239.517 58.1159 238.681C58.5341 238.08 58.7824 237.061 57.0051 235.846L58.7824 237.061C59.6971 237.61 60.8732 237.335 61.4482 236.447C61.984 235.663 61.6181 234.487 60.5857 233.598L61.9709 234.369C62.9641 234.97 64.2709 234.617 64.8197 233.546C65.2902 232.618 64.9243 231.481 64.0618 230.906L62.1016 229.56L64.5192 230.501C65.6169 231.063 66.9759 230.619 67.5117 229.456C67.9691 228.463 67.564 227.287 66.6623 226.659L55.058 218.649Z"
                fill="#FFB8BC"
            />
            <path
                d="M48.1704 232.88C48.1704 232.88 42.7473 239.7 32.7765 228.58L43.8188 219.159L53.9464 213.318C54.8873 212.783 56.0765 212.952 56.8213 213.75C57.5401 214.52 57.6577 215.67 57.0958 216.559L55.2924 219.473"
                fill="#FFB8BC"
            />
            <path
                d="M86.8752 99.0479C87.9468 111.84 78.4464 123.078 65.6661 124.15C52.8727 125.221 39.3344 115.081 38.2628 102.302C37.1912 89.509 48.9784 78.9117 61.7719 77.8402C74.5653 76.7688 85.8036 86.2684 86.8752 99.0479Z"
                fill="#2D4559"
            />
            <path
                d="M75.5855 108.09C75.7292 111.527 78.5388 114.205 81.8711 114.075C85.1903 113.944 87.7778 111.069 87.6209 107.633C87.4772 104.196 84.6676 101.517 81.3353 101.648C78.0161 101.779 75.4417 104.667 75.5855 108.09Z"
                fill="#2D4559"
            />
            <path
                d="M73.763 124.319L75.3834 139.085C75.9584 144.273 73.1749 147.369 68.2222 147.866C64.0013 148.284 60.277 146.742 59.9634 142.156L58.4998 118.792L73.763 124.319Z"
                fill="#FFB8BC"
            />
            <path
                d="M69.7972 129.102C78.239 128.2 84.4463 120.569 83.9105 113.434L82.5514 96.6042C81.885 87.6533 74.4624 80.8193 65.7723 81.146C56.8862 81.4857 48.4313 89.2606 48.8233 98.4336L50.0517 111.958C51.0187 122.425 59.6304 129.494 69.7972 129.102Z"
                fill="#FFB8BC"
            />
            <path
                d="M54.5209 140.404L78.0169 139.516C78.0169 139.516 78.7225 147.787 70.4506 148.741C56.6771 150.322 54.5209 140.404 54.5209 140.404Z"
                fill="#FFB8BC"
            />
            <path
                d="M85.6465 95.6112C85.6465 95.6112 84.0653 93.233 81.8045 90.8549C80.2495 86.2814 76.7995 81.5643 69.2333 80.1922C54.6495 77.5658 44.0907 86.974 45.3975 100.851L43.0322 100.969L45.8157 103.634C45.881 103.961 45.9464 104.275 46.0248 104.601L47.031 104.784L53.97 111.448C53.97 111.448 54.6887 108.352 55.3421 105.411C58.4654 104.288 64.568 100.851 70.4747 90.489C70.4747 90.489 77.3092 97.7411 82.8108 100.145C82.85 100.341 82.9022 100.524 82.9153 100.733C82.9153 100.733 82.9414 100.537 82.9676 100.211C83.4772 100.42 83.9738 100.616 84.4573 100.733L85.6465 95.6112Z"
                fill="#2D4559"
            />
            <path
                d="M48.2451 94.8268C7.32965 94.5524 6.62399 78.5454 18.4504 69.2287C30.2768 59.9119 48.1536 89.8353 48.1536 89.8353L48.2451 94.8268Z"
                fill="#2D4559"
            />
            <path
                d="M42.2846 113.212C42.4283 116.61 45.2118 119.262 48.5049 119.132C51.798 119.001 54.3462 116.152 54.2025 112.755C54.0587 109.358 51.2753 106.705 47.9822 106.836C44.6891 106.966 42.1409 109.815 42.2846 113.212Z"
                fill="#FFB8BC"
            />
        </svg>
    )
}
